"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var audioTrackSymbol = Symbol('audioTrack');
var contactSymbol = Symbol('contact');
var directionSymbol = Symbol('direction');
var idSymbol = Symbol('id');
var isMutedSymbol = Symbol('isMuted');
var isOnHoldSymbol = Symbol('isOnHold');
var onAcceptSymbol = Symbol('onAccept');
var onByeSymbol = Symbol('onBye');
var oncloseSymbol = Symbol('onClose');
var onConnectSymbol = Symbol('onConnect');
var onFailedSymbol = Symbol('onFailed');
var onPauseSymbol = Symbol('onPause');
var onProgressSymbol = Symbol('onProgress');
var onReinviteSymbol = Symbol('onReinvite');
var onRejectedSymbol = Symbol('onRejected');
var onResumeSymbol = Symbol('onResume');
var onTerminatedSymbol = Symbol('onTerminated');
var sessionSymbol = Symbol('session');
var statusSymbol = Symbol('status');
var streamSymbol = Symbol('stream');
var streamSymbolURL = Symbol('streamURL');
var typeSymbol = Symbol('type');
var userIdSymbol = Symbol('userId');
var videoTrackSymbol = Symbol('videoTrack');

var Session = /*#__PURE__*/function () {
  function Session(_ref) {
    var _ref$audioTrack = _ref.audioTrack,
        audioTrack = _ref$audioTrack === void 0 ? null : _ref$audioTrack,
        _ref$contact = _ref.contact,
        contact = _ref$contact === void 0 ? null : _ref$contact,
        _ref$direction = _ref.direction,
        direction = _ref$direction === void 0 ? 'local' : _ref$direction,
        _ref$id = _ref.id,
        id = _ref$id === void 0 ? null : _ref$id,
        _ref$isMuted = _ref.isMuted,
        isMuted = _ref$isMuted === void 0 ? false : _ref$isMuted,
        _ref$isOnHold = _ref.isOnHold,
        isOnHold = _ref$isOnHold === void 0 ? false : _ref$isOnHold,
        _ref$session = _ref.session,
        session = _ref$session === void 0 ? null : _ref$session,
        _ref$status = _ref.status,
        status = _ref$status === void 0 ? 'trying' : _ref$status,
        _ref$stream = _ref.stream,
        stream = _ref$stream === void 0 ? null : _ref$stream,
        _ref$type = _ref.type,
        type = _ref$type === void 0 ? 'session' : _ref$type,
        _ref$userId = _ref.userId,
        userId = _ref$userId === void 0 ? null : _ref$userId,
        _ref$videoTrack = _ref.videoTrack,
        videoTrack = _ref$videoTrack === void 0 ? null : _ref$videoTrack;
    (0, _classCallCheck2.default)(this, Session);
    this.audioTrack = audioTrack;
    this.contact = contact;
    this[directionSymbol] = direction;
    this[idSymbol] = id;
    this.isMuted = isMuted;
    this.isOnHold = isOnHold;
    this.status = status;
    this.session = session;
    this[typeSymbol] = type;
    this[userIdSymbol] = userId;
    this.videoTrack = videoTrack;

    if (stream) {
      this.stream = stream;
    }

    if (isMuted) {
      this.mute();
    }
  }

  (0, _createClass2.default)(Session, [{
    key: "audioTrack",
    get: function get() {
      return this[audioTrackSymbol];
    },
    set: function set(audioTrack) {
      this[audioTrackSymbol] = audioTrack;
    }
  }, {
    key: "contact",
    get: function get() {
      return this[contactSymbol];
    },
    set: function set(contact) {
      this[contactSymbol] = contact;
    }
  }, {
    key: "direction",
    get: function get() {
      return this[directionSymbol];
    }
  }, {
    key: "id",
    get: function get() {
      return this[idSymbol];
    }
  }, {
    key: "isMuted",
    get: function get() {
      return this[isMutedSymbol];
    },
    set: function set(isMuted) {
      this[isMutedSymbol] = isMuted;
    }
  }, {
    key: "isOnHold",
    get: function get() {
      return this[isOnHoldSymbol];
    },
    set: function set(isOnHold) {
      this[isOnHoldSymbol] = isOnHold;
    }
  }, {
    key: "onAccept",
    set: function set(fn) {
      // attach to session
      this[onAcceptSymbol] = fn;

      if (this[sessionSymbol]) {
        this[sessionSymbol].on('accepted', fn);
      }
    }
  }, {
    key: "onBye",
    set: function set(fn) {
      // attach to session
      this[onByeSymbol] = fn;

      if (this[sessionSymbol]) {
        this[sessionSymbol].on('bye', fn);
      }
    }
  }, {
    key: "onClose",
    set: function set(fn) {
      // attach to session
      this[oncloseSymbol] = fn;

      if (this[sessionSymbol]) {
        this[sessionSymbol].on('close', fn);
      }
    }
  }, {
    key: "onConnect",
    set: function set(fn) {
      // attach to session
      this[onConnectSymbol] = fn;

      if (this[sessionSymbol]) {
        this[sessionSymbol].on('connected', fn);
      }
    }
  }, {
    key: "onFailed",
    set: function set(fn) {
      // attach to session
      this[onFailedSymbol] = fn;

      if (this[sessionSymbol]) {
        this[sessionSymbol].on('failed', fn);
      }
    }
  }, {
    key: "onPause",
    set: function set(fn) {
      // attach to session
      this[onPauseSymbol] = fn;

      if (this[sessionSymbol]) {
        this[sessionSymbol].on('pause', fn);
      }
    }
  }, {
    key: "onProgress",
    set: function set(fn) {
      // attach to session
      this[onProgressSymbol] = fn;

      if (this[sessionSymbol]) {
        this[sessionSymbol].on('progress', fn);
      }
    }
  }, {
    key: "onReinvite",
    set: function set(fn) {
      // attach to session
      this[onReinviteSymbol] = fn;

      if (this[sessionSymbol]) {
        this[sessionSymbol].on('reinvite', fn);
      }
    }
  }, {
    key: "onRejected",
    set: function set(fn) {
      // attach to session
      this[onRejectedSymbol] = fn;

      if (this[sessionSymbol]) {
        this[sessionSymbol].on('rejected', fn);
      }
    }
  }, {
    key: "onResume",
    set: function set(fn) {
      // attach to session
      this[onResumeSymbol] = fn;

      if (this[sessionSymbol]) {
        this[sessionSymbol].on('resume', fn);
      }
    }
  }, {
    key: "onTerminated",
    set: function set(fn) {
      // attach to session
      this[onTerminatedSymbol] = fn;

      if (this[sessionSymbol]) {
        this[sessionSymbol].on('terminated', fn);
      }
    }
  }, {
    key: "session",
    get: function get() {
      return this[sessionSymbol];
    },
    set: function set(session) {
      this[sessionSymbol] = session;
    }
  }, {
    key: "status",
    get: function get() {
      return this[statusSymbol];
    },
    set: function set(status) {
      this[statusSymbol] = status;
    }
  }, {
    key: "stream",
    get: function get() {
      return this[streamSymbol];
    },
    set: function set(stream) {
      this[streamSymbol] = stream;
      this.streamURL = window.URL.createObjectURL(stream);
    }
  }, {
    key: "streamURL",
    get: function get() {
      return this[streamSymbolURL];
    },
    set: function set(streamURL) {
      this[streamSymbolURL] = streamURL;
    }
  }, {
    key: "type",
    get: function get() {
      return this[typeSymbol];
    }
  }, {
    key: "userId",
    get: function get() {
      return this[userIdSymbol];
    }
  }, {
    key: "videoTrack",
    get: function get() {
      return this[videoTrackSymbol];
    },
    set: function set(videoTrack) {
      this[videoTrackSymbol] = videoTrack;
    }
  }, {
    key: "hold",
    value: function hold() {
      this[isOnHoldSymbol] = true;
      this[sessionSymbol].hold();
    }
  }, {
    key: "unhold",
    value: function unhold() {
      this[isOnHoldSymbol] = false;
      this[sessionSymbol].unhold();
    }
  }, {
    key: "mute",
    value: function mute() {
      this.isMuted = true;

      if (this[sessionSymbol]) {
        this[sessionSymbol].mute();
      }
    }
  }, {
    key: "unmute",
    value: function unmute() {
      this.isMuted = false;

      if (this[sessionSymbol]) {
        this[sessionSymbol].unmute();
      }
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        contact: this.contact,
        direction: this.direction,
        id: this.id,
        isMuted: this.isMuted,
        isOnHold: this.isOnHold,
        status: this.status,
        session: this.session,
        type: this.type,
        userId: this.userId
      };
    }
  }]);
  return Session;
}();

exports.default = Session;
module.exports = exports.default;